import io from 'socket.io-client';

class SocketIoHelper {
	constructor() {
		this.socket = null;
	}

	initialize(url) {
		if (this.socket) return;
		this.socket = io(url);
	}
}

export default new SocketIoHelper();
